const ENTOURAGE = "ENTOURAGE";
const DIGITAL_SPONSOR = "DIGITAL_SPONSOR";

export {ENTOURAGE, DIGITAL_SPONSOR};
